import React from 'react';
import { Printer, ChevronLeft, DollarSign } from 'lucide-react';

// Admin Job Order View (with pricing)
export const AdminJobOrderView = ({ job, customer, estimateItems, onBack, onPrint, onSwitchToWorkerView }) => {
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const printContent = document.querySelector('.admin-job-order-print-content');

    const contentDiv = document.createElement('div');
    contentDiv.innerHTML = printContent.innerHTML;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Admin Job Order ${job.job_number}</title>
          <style>
            body {
              font-family: system-ui, -apple-system, sans-serif;
              margin: 0;
              padding: 16px;
              line-height: 1.3;
            }
            .job-header {
              text-align: center;
              margin-bottom: 1.5rem;
              border-bottom: 2px solid #ec4899;
              padding-bottom: 0.75rem;
            }
            .company-logo {
              height: 3.5rem;
              max-width: 14rem;
              margin: 0 auto 0.5rem;
              display: block;
            }
            .company-info {
              color: #4b5563;
              font-size: 0.75rem;
              margin-top: 0.5rem;
            }
            .company-info p {
              margin: 0.1rem 0;
            }
            .grid { display: grid; }
            .grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
            .gap-6 { gap: 1.5rem; }
            .mb-4 { margin-bottom: 0.75rem; }
            .mb-3 { margin-bottom: 0.5rem; }
            .mb-2 { margin-bottom: 0.35rem; }
            .p-3 { padding: 0.5rem; }
            .bg-gray-50 { background-color: #f9fafb; }
            .bg-pink-50 { background-color: #fdf2f8; }
            .bg-yellow-50 { background-color: #fffbeb; }
            .rounded-lg { border-radius: 0.375rem; }
            .border { border: 1px solid #d1d5db; }
            .border-l-4 { border-left: 3px solid; }
            .border-pink-400 { border-left-color: #ec4899; }
            .border-t { border-top: 1px solid #d1d5db; }
            .border-gray-300 { border-color: #d1d5db; }
            .border-gray-200 { border-color: #e5e7eb; }
            .font-bold { font-weight: 700; }
            .font-semibold { font-weight: 600; }
            .font-medium { font-weight: 500; }
            .text-2xl { font-size: 1.25rem; }
            .text-lg { font-size: 1rem; }
            .text-sm { font-size: 0.8125rem; }
            .text-xs { font-size: 0.75rem; }
            .text-gray-800 { color: #1f2937; }
            .text-gray-700 { color: #374151; }
            .text-gray-600 { color: #4b5563; }
            .text-gray-500 { color: #6b7280; }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .space-y-1 > * + * { margin-top: 0.25rem; }
            .flex { display: flex; }
            .justify-between { justify-content: space-between; }
            .w-28 { width: 7rem; }
            .whitespace-pre-wrap { white-space: pre-wrap; }
            table { width: 100%; border-collapse: collapse; margin-top: 0.75rem; }
            th, td { padding: 0.5rem 0.75rem; text-align: left; }
            th { background-color: #f9fafb; font-weight: 600; color: #374151; font-size: 0.75rem; }
            .text-right th, .text-right td { text-align: right; }
            .border-t-row { border-top: 1px solid #e5e7eb; }
            .mt-3 { margin-top: 0.5rem; }
            .admin-badge {
              background-color: #ec4899;
              color: white;
              padding: 0.25rem 0.75rem;
              border-radius: 0.25rem;
              font-size: 0.75rem;
              font-weight: 600;
              display: inline-block;
              margin-bottom: 0.5rem;
            }
            @page { margin: 0.5in; }
            @media print {
              body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>
          <div class="job-header">
            <img
              src="${window.location.origin}/jft-logo.png"
              alt="JFT Contracting"
              class="company-logo"
              onerror="this.style.display='none';"
            />
            <div class="company-info">
              <p class="font-semibold">Professional Contracting Services</p>
              <p>Thunder Bay, Ontario • (807) 555-0123 • info@jftcontracting.com</p>
            </div>
          </div>
          <div class="admin-badge">ADMIN COPY - CONFIDENTIAL</div>
          ${contentDiv.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full max-h-[95vh] overflow-auto">
        {/* Header Controls */}
        <div className="flex justify-between items-center p-4 border-b bg-pink-50">
          <h2 className="text-xl font-bold text-gray-800">Admin Job Order (With Pricing)</h2>
          <div className="flex space-x-2">
            {onSwitchToWorkerView && (
              <button
                onClick={onSwitchToWorkerView}
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors text-sm"
              >
                Switch to Worker View
              </button>
            )}
            <button
              onClick={handlePrint}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors"
            >
              <Printer size={16} />
              <span>Print</span>
            </button>
            <button
              onClick={onBack}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors"
            >
              <ChevronLeft size={16} />
              <span>Back</span>
            </button>
          </div>
        </div>

        {/* Job Order Document */}
        <div className="admin-job-order-print-content p-6 bg-white">
          {/* Job Order Header */}
          <div className="text-center mb-4 border-b border-pink-300 pb-3">
            <h1 className="text-2xl font-bold text-pink-600 mb-2">ADMIN JOB ORDER</h1>
            <p className="text-sm text-red-600 font-semibold">CONFIDENTIAL - PRICING INCLUDED</p>
          </div>

          {/* Job Header */}
          <div className="grid grid-cols-2 gap-6 mb-4">
            <div>
              <h2 className="text-lg font-bold text-gray-800 mb-3">JOB INFORMATION</h2>
              <div className="space-y-1">
                <div className="flex">
                  <span className="font-semibold w-28 text-sm">Job Number:</span>
                  <span className="text-sm">{job.job_number}</span>
                </div>
                <div className="flex">
                  <span className="font-semibold w-28 text-sm">Start Date:</span>
                  <span className="text-sm">{job.start_date ? new Date(job.start_date).toLocaleDateString() : 'Not set'}</span>
                </div>
                <div className="flex">
                  <span className="font-semibold w-28 text-sm">Status:</span>
                  <span className="text-sm">{job.status}</span>
                </div>
                {job.estimate_id && (
                  <div className="flex">
                    <span className="font-semibold w-28 text-sm">From Estimate:</span>
                    <span className="text-sm">{job.estimate?.estimate_number || 'N/A'}</span>
                  </div>
                )}
              </div>
            </div>

            {/* Customer Information */}
            <div>
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Customer:</h3>
              <div className="bg-gray-50 p-3 rounded-lg text-sm">
                <div className="font-semibold text-gray-800">
                  {customer?.first_name} {customer?.last_name}
                </div>
                {customer?.company && (
                  <div className="text-gray-600 text-xs">{customer.company}</div>
                )}
                <div className="text-gray-600 mt-1.5 text-xs">
                  <div>{customer?.address}</div>
                  <div>{customer?.city}, {customer?.province} {customer?.postal_code}</div>
                </div>
                <div className="text-gray-600 mt-1.5 text-xs">
                  <div>Phone: {customer?.phone}</div>
                  {customer?.email && <div>Email: {customer.email}</div>}
                </div>
              </div>
            </div>
          </div>

          {/* Job Location */}
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Job Location:</h3>
            <div className="bg-pink-50 p-3 rounded-lg text-sm">
              <div>{job.job_address}</div>
              <div>{job.job_city}, {job.job_province} {job.job_postal_code}</div>
            </div>
          </div>

          {/* Estimate Items - WITH PRICING */}
          {estimateItems && estimateItems.length > 0 && (
            <div className="mb-4">
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Job Items & Pricing:</h3>
              <div className="border border-gray-300 rounded-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-pink-50">
                    <tr>
                      <th className="px-3 py-2 text-left font-semibold text-gray-700 text-xs">Description</th>
                      <th className="px-3 py-2 text-center font-semibold text-gray-700 w-16 text-xs">Qty</th>
                      <th className="px-3 py-2 text-right font-semibold text-gray-700 w-20 text-xs">Unit Price</th>
                      <th className="px-3 py-2 text-right font-semibold text-gray-700 w-20 text-xs">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {estimateItems.map((item, index) => (
                      <tr key={item.id || index} className="border-t border-gray-200">
                        <td className="px-3 py-2 text-gray-800 text-sm">{item.description}</td>
                        <td className="px-3 py-2 text-center text-gray-600 text-sm">{item.quantity}</td>
                        <td className="px-3 py-2 text-right text-gray-600 text-sm">
                          ${parseFloat(item.unit_price || 0).toFixed(2)}
                        </td>
                        <td className="px-3 py-2 text-right font-medium text-gray-800 text-sm">
                          ${parseFloat(item.line_total || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Total Amount - PRICING */}
          <div className="flex justify-end mb-4">
            <div className="bg-pink-100 border-2 border-pink-400 p-4 rounded-lg">
              <div className="flex items-center space-x-3">
                <DollarSign className="text-pink-600" size={24} />
                <div>
                  <div className="text-xs text-gray-600 font-medium">Job Total Amount</div>
                  <div className="text-2xl font-bold text-pink-700">${parseFloat(job.total_amount || 0).toFixed(2)}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Notes */}
          {job.notes && (
            <div className="mb-4">
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Admin Notes:</h3>
              <div className="bg-yellow-50 p-3 rounded-lg border-l-4 border-yellow-400">
                <p className="text-gray-700 whitespace-pre-wrap text-xs">{job.notes}</p>
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="mt-4 text-center text-xs text-gray-500 border-t border-gray-200 pt-2">
            <p className="text-red-600 font-semibold mb-1">CONFIDENTIAL DOCUMENT - ADMIN USE ONLY</p>
            <p>JFT Contracting • Thunder Bay, Ontario • This document contains pricing information</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Worker Job Order View (without pricing)
export const WorkerJobOrderView = ({ job, customer, estimateItems, onBack, onPrint, onSwitchToAdminView }) => {
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const printContent = document.querySelector('.worker-job-order-print-content');

    const contentDiv = document.createElement('div');
    contentDiv.innerHTML = printContent.innerHTML;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Job Order ${job.job_number}</title>
          <style>
            body {
              font-family: system-ui, -apple-system, sans-serif;
              margin: 0;
              padding: 16px;
              line-height: 1.3;
            }
            .job-header {
              text-align: center;
              margin-bottom: 1.5rem;
              border-bottom: 2px solid #3b82f6;
              padding-bottom: 0.75rem;
            }
            .company-logo {
              height: 3.5rem;
              max-width: 14rem;
              margin: 0 auto 0.5rem;
              display: block;
            }
            .company-info {
              color: #4b5563;
              font-size: 0.75rem;
              margin-top: 0.5rem;
            }
            .company-info p {
              margin: 0.1rem 0;
            }
            .grid { display: grid; }
            .grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
            .gap-6 { gap: 1.5rem; }
            .mb-4 { margin-bottom: 0.75rem; }
            .mb-3 { margin-bottom: 0.5rem; }
            .mb-2 { margin-bottom: 0.35rem; }
            .p-3 { padding: 0.5rem; }
            .bg-gray-50 { background-color: #f9fafb; }
            .bg-blue-50 { background-color: #eff6ff; }
            .bg-yellow-50 { background-color: #fffbeb; }
            .rounded-lg { border-radius: 0.375rem; }
            .border { border: 1px solid #d1d5db; }
            .border-l-4 { border-left: 3px solid; }
            .border-blue-400 { border-left-color: #3b82f6; }
            .border-t { border-top: 1px solid #d1d5db; }
            .border-gray-300 { border-color: #d1d5db; }
            .border-gray-200 { border-color: #e5e7eb; }
            .font-bold { font-weight: 700; }
            .font-semibold { font-weight: 600; }
            .font-medium { font-weight: 500; }
            .text-2xl { font-size: 1.25rem; }
            .text-lg { font-size: 1rem; }
            .text-sm { font-size: 0.8125rem; }
            .text-xs { font-size: 0.75rem; }
            .text-gray-800 { color: #1f2937; }
            .text-gray-700 { color: #374151; }
            .text-gray-600 { color: #4b5563; }
            .text-gray-500 { color: #6b7280; }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .space-y-1 > * + * { margin-top: 0.25rem; }
            .flex { display: flex; }
            .justify-between { justify-content: space-between; }
            .w-28 { width: 7rem; }
            .whitespace-pre-wrap { white-space: pre-wrap; }
            table { width: 100%; border-collapse: collapse; margin-top: 0.75rem; }
            th, td { padding: 0.5rem 0.75rem; text-align: left; }
            th { background-color: #f9fafb; font-weight: 600; color: #374151; font-size: 0.75rem; }
            .text-center th, .text-center td { text-align: center; }
            .border-t-row { border-top: 1px solid #e5e7eb; }
            .mt-3 { margin-top: 0.5rem; }
            .worker-badge {
              background-color: #3b82f6;
              color: white;
              padding: 0.25rem 0.75rem;
              border-radius: 0.25rem;
              font-size: 0.75rem;
              font-weight: 600;
              display: inline-block;
              margin-bottom: 0.5rem;
            }
            @page { margin: 0.5in; }
            @media print {
              body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>
          <div class="job-header">
            <img
              src="${window.location.origin}/jft-logo.png"
              alt="JFT Contracting"
              class="company-logo"
              onerror="this.style.display='none';"
            />
            <div class="company-info">
              <p class="font-semibold">Professional Contracting Services</p>
              <p>Thunder Bay, Ontario • (807) 555-0123 • info@jftcontracting.com</p>
            </div>
          </div>
          <div class="worker-badge">WORKER COPY</div>
          ${contentDiv.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full max-h-[95vh] overflow-auto">
        {/* Header Controls */}
        <div className="flex justify-between items-center p-4 border-b bg-blue-50">
          <h2 className="text-xl font-bold text-gray-800">Worker Job Order (For Shift Boss)</h2>
          <div className="flex space-x-2">
            {onSwitchToAdminView && (
              <button
                onClick={onSwitchToAdminView}
                className="bg-pink-500 hover:bg-pink-600 text-white px-4 py-2 rounded-lg transition-colors text-sm"
              >
                Switch to Admin View
              </button>
            )}
            <button
              onClick={handlePrint}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors"
            >
              <Printer size={16} />
              <span>Print</span>
            </button>
            <button
              onClick={onBack}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors"
            >
              <ChevronLeft size={16} />
              <span>Back</span>
            </button>
          </div>
        </div>

        {/* Job Order Document */}
        <div className="worker-job-order-print-content p-6 bg-white">
          {/* Job Order Header */}
          <div className="text-center mb-4 border-b border-blue-300 pb-3">
            <h1 className="text-2xl font-bold text-blue-600 mb-2">JOB ORDER</h1>
            <p className="text-sm text-blue-600 font-semibold">For Shift Boss / Workers</p>
          </div>

          {/* Job Header */}
          <div className="grid grid-cols-2 gap-6 mb-4">
            <div>
              <h2 className="text-lg font-bold text-gray-800 mb-3">JOB INFORMATION</h2>
              <div className="space-y-1">
                <div className="flex">
                  <span className="font-semibold w-28 text-sm">Job Number:</span>
                  <span className="text-sm">{job.job_number}</span>
                </div>
                <div className="flex">
                  <span className="font-semibold w-28 text-sm">Start Date:</span>
                  <span className="text-sm">{job.start_date ? new Date(job.start_date).toLocaleDateString() : 'Not set'}</span>
                </div>
                <div className="flex">
                  <span className="font-semibold w-28 text-sm">Status:</span>
                  <span className="text-sm">{job.status}</span>
                </div>
              </div>
            </div>

            {/* Customer Information */}
            <div>
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Customer:</h3>
              <div className="bg-gray-50 p-3 rounded-lg text-sm">
                <div className="font-semibold text-gray-800">
                  {customer?.first_name} {customer?.last_name}
                </div>
                {customer?.company && (
                  <div className="text-gray-600 text-xs">{customer.company}</div>
                )}
                <div className="text-gray-600 mt-1.5 text-xs">
                  <div>Phone: {customer?.phone}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Job Location */}
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Job Location:</h3>
            <div className="bg-blue-50 p-3 rounded-lg text-sm">
              <div className="font-semibold">{job.job_address}</div>
              <div>{job.job_city}, {job.job_province} {job.job_postal_code}</div>
            </div>
          </div>

          {/* Work Items - NO PRICING */}
          {estimateItems && estimateItems.length > 0 && (
            <div className="mb-4">
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Work to be Completed:</h3>
              <div className="border border-gray-300 rounded-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-blue-50">
                    <tr>
                      <th className="px-3 py-2 text-left font-semibold text-gray-700 text-xs">Description</th>
                      <th className="px-3 py-2 text-center font-semibold text-gray-700 w-24 text-xs">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {estimateItems.map((item, index) => (
                      <tr key={item.id || index} className="border-t border-gray-200">
                        <td className="px-3 py-2 text-gray-800 text-sm">{item.description}</td>
                        <td className="px-3 py-2 text-center text-gray-600 text-sm">{item.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Notes (filtered - no pricing info) */}
          {job.notes && (
            <div className="mb-4">
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Job Notes:</h3>
              <div className="bg-yellow-50 p-3 rounded-lg border-l-4 border-blue-400">
                <p className="text-gray-700 whitespace-pre-wrap text-xs">{job.notes}</p>
              </div>
            </div>
          )}

          {/* Completion Checklist */}
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Completion Checklist:</h3>
            <div className="bg-gray-50 p-3 rounded-lg space-y-2 text-xs">
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="w-4 h-4" />
                <span>All work items completed as specified</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="w-4 h-4" />
                <span>Work area cleaned and debris removed</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="w-4 h-4" />
                <span>Customer walkthrough completed</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="w-4 h-4" />
                <span>All equipment and tools accounted for</span>
              </label>
            </div>
          </div>

          {/* Signature Section */}
          <div className="mt-4 border-t border-gray-300 pt-3">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Completion Signatures:</h3>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <div className="border-b border-gray-400 mb-1 h-10"></div>
                <p className="text-xs text-gray-600">Shift Boss / Lead Worker</p>
              </div>
              <div>
                <div className="border-b border-gray-400 mb-1 h-10"></div>
                <p className="text-xs text-gray-600">Date Completed</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-4 text-center text-xs text-gray-500 border-t border-gray-200 pt-2">
            <p>JFT Contracting • Thunder Bay, Ontario • Worker Copy</p>
          </div>
        </div>
      </div>
    </div>
  );
};
